import React, { useMemo } from 'react';
import { Col, Row } from 'reactstrap';
import { WrapperField } from '../../../../../components/InputField/WrapperField';
import ButtonGroupNew from '../../BusinessLiteForms/components/ButtonGroupNew';



const AboutBusiness = ({ errors, applicationForm, asLabel, editMode, data, handleChange, pageNum, loading, step, decrementStep, handleSubmit, bPrimeJSON, showErr, setErrors }) => {

    const hasPlusApplicationWithoutAccountCreated = useMemo(() => !applicationForm?.cyclosUserId && applicationForm?.plus_id, [applicationForm?.cyclosUserId, applicationForm?.plus_id])

    return (
        <>
            <div className='mb-3'>
                <h2 style={{ fontWeight: 'bolder' }} className='pt-3'>About your business</h2>

                {/* {data?.primaryBusiness && hasPlusApplicationWithoutAccountCreated ? null : */}
                <WrapperField
                    disabled={asLabel}
                    jsonField={bPrimeJSON["primaryBusiness"]}
                    dataObj={data}
                    onChange={(updatedData) => handleChange(updatedData)}
                    showError={showErr}
                    onError={(errorMsg) => setErrors((prevErrors) => ({ ...prevErrors, primaryBusiness: errorMsg }))}
                />
                {/* } */}

                <WrapperField
                    disabled={asLabel}
                    jsonField={bPrimeJSON["hasBusinessPlan"]}
                    dataObj={data}
                    onChange={(updatedData) => handleChange(updatedData)}
                    showError={showErr}
                    onError={(errorMsg) => setErrors((prevErrors) => ({ ...prevErrors, hasBusinessPlan: errorMsg }))}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={bPrimeJSON["productsOrServices"]}
                    dataObj={data}
                    onChange={(updatedData) => handleChange(updatedData)}
                    showError={showErr}
                    className="my-3"
                    onError={(errorMsg) => setErrors((prevErrors) => ({ ...prevErrors, productsOrServices: errorMsg }))}
                />

                <WrapperField
                    disabled={asLabel}
                    jsonField={bPrimeJSON["businessPurpose"]}
                    dataObj={data}
                    onChange={(updatedData) => handleChange(updatedData)}
                    showError={showErr}
                    className="my-3"
                    onError={(errorMsg) => setErrors((prevErrors) => ({ ...prevErrors, businessPurpose: errorMsg }))}
                />

                {/* {data?.primaryCustomer && hasPlusApplicationWithoutAccountCreated ? null : */}
                <WrapperField
                    disabled={asLabel}
                    jsonField={bPrimeJSON["primaryCustomer"]}
                    dataObj={data}
                    onChange={(updatedData) => handleChange(updatedData)}
                    showError={showErr}
                    className="my-3"
                    onError={(errorMsg) => setErrors((prevErrors) => ({ ...prevErrors, primaryCustomer: errorMsg }))}
                />
                {/* } */}

                <WrapperField
                    disabled={asLabel}
                    jsonField={bPrimeJSON["revenueRange"]}
                    dataObj={data}
                    onChange={(updatedData) => handleChange(updatedData)}
                    showError={showErr}
                    className="my-3"
                    onError={(errorMsg) => setErrors((prevErrors) => ({ ...prevErrors, revenueRange: errorMsg }))}
                />

                <Row>
                    <Col className='col-md-6 col-12'>

                        <WrapperField
                            disabled={asLabel}
                            jsonField={bPrimeJSON["hasAuditStatements"]}
                            dataObj={data}
                            onChange={(updatedData) => handleChange(updatedData)}
                            showError={showErr}
                            className="my-3"
                            onError={(errorMsg) => setErrors((prevErrors) => ({ ...prevErrors, hasAuditStatements: errorMsg }))}
                        />

                    </Col>

                    <Col className='col-md-6 col-12'>
                        <WrapperField
                            disabled={asLabel}
                            jsonField={bPrimeJSON["hasAnnualStatements"]}
                            dataObj={data}
                            onChange={(updatedData) => handleChange(updatedData)}
                            showError={showErr}
                            className="my-3"
                            onError={(errorMsg) => setErrors((prevErrors) => ({ ...prevErrors, hasAnnualStatements: errorMsg }))}
                        />

                    </Col>
                </Row>

                <WrapperField
                    disabled={asLabel}
                    jsonField={bPrimeJSON["hasFinancialForecast"]}
                    dataObj={data}
                    onChange={(updatedData) => handleChange(updatedData)}
                    showError={showErr}
                    className="my-3"
                    onError={(errorMsg) => setErrors((prevErrors) => ({ ...prevErrors, hasFinancialForecast: errorMsg }))}
                />

                {data?.businessInvolvements?.length && hasPlusApplicationWithoutAccountCreated ? null :
                    <WrapperField
                        disabled={asLabel}
                        jsonField={bPrimeJSON["businessInvolvements"]}
                        dataObj={data}
                        onChange={(updatedData) => handleChange(updatedData)}
                        showError={showErr}
                        onError={(errorMsg) => setErrors((prevErrors) => ({ ...prevErrors, businessInvolvements: errorMsg }))}
                    />
                }


            </div>
            <ButtonGroupNew
                isDisabled={asLabel || editMode}
                pageNum={pageNum}
                showPageNum={false}
                loading={loading}
                asLabel={asLabel || editMode}
                limit={10}
                onNextClick={() => handleSubmit({ isLastStep: false })}
                step={step}
                onBackClick={decrementStep}
            />
        </>
    )
}

export default AboutBusiness;
